// LogoCarousel.jsx
import React from "react";
import { Box } from "@mui/material";
import { styled } from "styled-components";

const CarouselContainer = styled(Box)`
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  position: relative;
  margin: 25px 0;
`;

const SlideTrack = styled(Box)`
  display: inline-flex;
  animation: scroll 30s linear infinite;

  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }
`;

const LogoItem = styled(Box)`
  flex: 0 0 auto;
  width: 120px;
  margin: 0 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: auto;
    ${'' /* filter: grayscale(100%); */}
    opacity: 0.95;
    transition: all 0.3s ease;

    &:hover {
      ${'' /* filter: grayscale(0%); */}
      opacity: 1;
      transform: scale(1.05);
    }
  }
`;

const logos = [
  "/Images/ClientLogos/p1.png",
  "/Images/ClientLogos/p2.png",
  "/Images/ClientLogos/p12.png",
  "/Images/ClientLogos/p-1.png",
  "/Images/ClientLogos/p-2.png",
  "/Images/ClientLogos/p-3.png",
  "/Images/ClientLogos/p-4.png",
  "/Images/ClientLogos/p-5.png",
  "/Images/ClientLogos/p-7.png",
  "/Images/ClientLogos/p-8.png",
  "/Images/ClientLogos/p-9.png",
  "/Images/ClientLogos/shield.png",
  "/Images/ClientLogos/SunPharma.png",
  "/Images/ClientLogos/BSV.png",
  "/Images/ClientLogos/DrReddys.png",
  "/Images/ClientLogos/esperer.png",
  "/Images/ClientLogos/GreenSpace.png",
  "/Images/ClientLogos/jubilantPharmavo.png",
  "/Images/ClientLogos/legacyPharma.png",
];

const LogoCarousel = () => {
  return (
    <CarouselContainer>
      <SlideTrack>
        {[...logos, ...logos].map((logo, index) => (
          <LogoItem key={index}>
            <img src={logo} alt={`client-logo-${index}`} />
          </LogoItem>
        ))}
      </SlideTrack>
    </CarouselContainer>
  );
};

export default LogoCarousel;
